import React from 'react';
import type { GridApi } from 'ag-grid-community';

import useIsDataTable from 'components/DataTable/useIsDataTable';

import useRankingMatrixContent from './useRankingMatrixContent';
import RankingMatrixDataTableView from './RankingMatrixDataTableView';
import RankingMatrixView from './RankingMatrixView';

const RankingMatrixContentContainer = ({
  gadget,
  gridApi,
  setGridApi,
  setExportHandle,
}: {
  gadget: VisualisationDefinitions.RankingMatrix;
  gridApi?: GridApi;
  setGridApi: React.Dispatch<React.SetStateAction<GridApi | undefined>>;
  // What export menus use in place of the gridApi when DataTable draws it
  setExportHandle?: (handle: DataTable.ExportHandle | undefined) => void;
}) => {
  const isDataTable = useIsDataTable('rankingMatrix');
  const props = useRankingMatrixContent({ gadget, gridApi, setGridApi });
  return isDataTable ? (
    <RankingMatrixDataTableView
      {...props}
      gadget={gadget}
      setExportHandle={setExportHandle}
    />
  ) : (
    <RankingMatrixView {...props} />
  );
};

export default RankingMatrixContentContainer;
